var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate, } from "@azure/msal-react";
import { loginRequest } from "./Auth/AuthConfig";
import AuthLoader from "./Auth/AuthLoader";
import TokenConfig from "./Auth/TokenConfig";
var AppWithMSAL = function (_a) {
    var loginInstance = _a.loginInstance;
    var navigateLogin = function () {
        loginInstance
            .loginRedirect(__assign({}, loginRequest))
            .catch(function (error) { return console.error(error); });
    };
    return (_jsx(MsalProvider, __assign({ instance: loginInstance }, { children: _jsxs("div", { children: [_jsx(AuthenticatedTemplate, { children: _jsx(TokenConfig, { msalInstance: loginInstance }) }), _jsx(UnauthenticatedTemplate, { children: _jsx(AuthLoader, { navigate: navigateLogin }) })] }) })));
};
export default AppWithMSAL;
